import { EntityImageLookup } from "../loyaltyTypes";
import { CategoryType } from "../types";
import {
  resolveCategoryUuid,
  resolveItemUuid,
  resolveSubItemUuid,
} from "../cart/entityKeys";
import { getAllCategoryItems } from "../cart/menuLookup";

export const buildEntityImageLookup = (
  categories: CategoryType[]
): EntityImageLookup => {
  if (!categories?.length) {
    return {};
  }

  const lookup: EntityImageLookup = {};

  for (const category of categories) {
    const firstCategoryItemImage = category.itemCategories
      ?.map((itemCategory) => itemCategory.item?.img_url)
      .find(Boolean);
    if (firstCategoryItemImage) {
      const categoryKey = resolveCategoryUuid(category);
      if (categoryKey) {
        lookup[categoryKey] = { itemImage: firstCategoryItemImage };
      }
    }

    // Hidden items too, so an offer on one resolves. And items without an
    // image: `itemId` is what marks an offer target as existing.
    for (const itemCategory of getAllCategoryItems(category)) {
      const item = itemCategory.item;
      if (!item?.subItems?.length) {
        continue;
      }

      const entry = { itemImage: item.img_url || undefined, itemId: item.id };
      const itemKey = resolveItemUuid(item);
      if (itemKey) {
        lookup[itemKey] = entry;
      }

      for (const subItem of item.subItems) {
        const subItemKey = resolveSubItemUuid(subItem);
        if (subItemKey) {
          lookup[subItemKey] = entry;
        }
        if (subItem.id !== undefined && subItem.id !== null) {
          lookup[String(subItem.id)] = entry;
        }
      }
    }
  }

  return lookup;
};
